<div mat-dialog-title>
  <div class="row row--space-between row--valign-center">
    <label class="semi-bold">{{ 'App.RequestPayment.Labels.Payment' | translate }}</label>
    <button mat-button (click)="closePayment()" class="float-right">
      <span class="icon-x"></span>
    </button>
  </div>
</div>

<ng-container *ngIf="!isLoadingPaymentLink; else loadingPayment">
  <div mat-dialog-content class="payment-content align-center">
    <div *ngIf="!isPaymentConfirmed" class="display-inline-flex justify-content-center mb--sm">
      <span class="semi-bold text-medium color--navy">{{ 'App.RequestPayment.Labels.PaymentInstruction' | translate }}</span>
    </div>
    <!-- Payment Data Section -->
      <div class="row column--12 display-column-flex row--valign-center row--no-gap mt--xs">
        <div class="display-inline-flex row--valign-center">
          <span class="semi-bold text-medium color--blue-grey mr--xs"
            >{{ 'App.RequestPayment.Labels.PickupFee' | translate }}:
          </span>
          <span class="semi-bold text-medium color--navy mr--xs">$ {{ data.collectionFee | number : '1.0-2' }}</span>
        </div>        
        <mat-divider class="w-100"></mat-divider>
        <div class="display-inline-flex row--valign-center mt--none">
          <span class="semi-bold text-medium color--blue-grey mr--xs"
            >{{ 'App.RequestPayment.Labels.Total' | translate }}:
          </span>
          <span class="semi-bold text-medium color--navy mr--xs"
            >$ {{ data.collectionFee | number : '1.0-2' }} +
            {{ 'App.RequestPayment.Labels.ApplicableTaxes' | translate }}*</span
          >
        </div>
      </div>
      <!-- QRCode Section -->
      <div class="display-flex justify-content-center">
        <ng-container *ngIf="!isPaymentConfirmed; else paymentConfirmed">
          <qrcode *ngIf="paymentLink" [qrdata]="paymentLink" [imageSrc]="'./logo/pp-logo-head-white.svg'"
          [imageHeight]="50"
          [imageWidth]="45"
          [colorDark]="'#000344'"
          [width]="260" [errorCorrectionLevel]="'M'"></qrcode>
        </ng-container>
        <ng-template #paymentConfirmed>
          <div class="row display-inline-flex row--valign-center payment-collected mt--md">
            <div class="subscription-icon icon-checked"></div>
            <span class="align-center">{{ 'App.RequestPayment.Labels.PaymentCollected' | translate }}</span>
          </div>
        </ng-template>
      </div>
    <!-- Buttons Section -->
    <div *ngIf="!isPaymentConfirmed" class="display-flex justify-content-center mb--sm">
      <a class="link" (click)="bypassPayment()">{{ 'App.RequestPayment.Buttons.RequestBypassPayment' | translate }}</a>
    </div>
  </div>
  <div class="row display-column-flex row--valign-center justify-content-center" mat-dialog-actions>
    @if(!isPaymentConfirmed){ @if(isLoadingConfirmation){
    <div class="row justify-content-center row--valign-center">
      <mat-spinner class="secondary-spinner" diameter="25"></mat-spinner>
      <span>{{ 'App.RequestPayment.Labels.WaitingPaymentConfirmation' | translate }}</span>
    </div>
    }
    <button mat-button class="primary-button rounded" (click)="refreshPayment()" [disabled]="isLoadingConfirmation">
      <span class="icon-refresh mr--xs"></span>
      <span>{{ 'App.RequestPayment.Buttons.CheckPaymentStatus' | translate }}</span>
    </button>
    }
    <button mat-button class="secondary-button rounded" (click)="closePayment()">
      <span class="icon-x mr--sm"></span>
      <span>{{
        (!isPaymentConfirmed ? 'App.RequestPayment.Buttons.Cancel' : 'App.RequestPayment.Buttons.Done') | translate
      }}</span>
    </button>
  </div>
</ng-container>

<!-- Loading Section -->
<ng-template #loadingPayment>
  <div class="grid--center my--lg">
    <mat-spinner class="primary-spinner"></mat-spinner>
  </div>
</ng-template>
